export default { keys: { x: "date" }, xFormat: "%b %Y" };
